





































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import OrderApi from '@/api/order/list'
@Component({
  components: {}
})
export default class LogisticsTracking extends AbpBase {
  tabList: any[] = []
  timeList: any[] = []
  loading = false

  created() {
    this.getOrderDetail()
  }

  tabClick(e) {
    let item = this.tabList[e]
    this.getTrackInfo(item.expressCompanyName, item.shipmentNumber)
  }

  /**
   * 获取订单详情
   */
  getOrderDetail() {
    let id = this.$route.query['id']
    if (id) {
      OrderApi.orderDetail(id.toString()).then(res => {
        this.tabList = res.data.expressPackages || []
        if (this.tabList.length > 0) {
          let item = this.tabList[0]
          this.getTrackInfo(item.expressCompanyName, item.shipmentNumber)
        }
      })
    }
  }

  /**
   * 获取物流信息
   */
  getTrackInfo(expressCompanyId: string, ShipperCode: string) {
    if (expressCompanyId && ShipperCode && !this.loading) {
      this.timeList = []
      this.loading = true
      OrderApi.getTrackInfo(expressCompanyId, ShipperCode).then(res => {
        this.loading = false
        this.timeList = res.data.traces.reverse() || []
      }).catch(err => {
        this.loading = false
      })
    }
  }
}
